module.exports = __webpack_public_path__ + "img/channel.78917175.png";